function lenghtCorrect(title, size) {
    let str = title;
    if (title.length > size) {
        str = title.substr(0, size) + `...`;
        return str;
    } else {
        return str;
    }
}

function toggleActive(parentSelector, filterType, selector) {
    const parent = parentSelector.querySelector(filterType);

    if (parent) {
        const arr = parent.querySelectorAll(selector);
        arr.forEach((el) => {
            el.addEventListener("click", () => {
                removeActive(arr);
                el.classList.add("active");
            });
        });
    } else return;
}

function removeActive(arr, clazz = 'active') {
    arr.forEach((item) => {
        item.classList.remove(clazz);
    });
}

function getElement(selector, elements = false,) {
    return elements ? document.querySelectorAll(selector) : document.querySelector(selector)
}

function toggleClass(selector){
    getElement(selector, true).forEach(item => {
        item.addEventListener('click', () => {
            item.classList.toggle('active');
        })
    })
}


export {lenghtCorrect, toggleActive, removeActive, getElement, toggleClass};
